import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AssignmentResponse } from '@lyrahealth-inc/shared-app-logic/src/models/assignments/Assignments'

import { clearSelectedClientId, setSelectedClientId } from '../../clients/clientDetails/data/ltClientSlice'

type AssignmentsState = {
  selectedAssignmentId: string | null
  responseDetails: AssignmentResponse | null
}
const initialState: AssignmentsState = {
  selectedAssignmentId: null,
  responseDetails: null,
}

const assignmentsSlice = createSlice({
  name: 'assignments',
  initialState,
  reducers: {
    setSelectedAssignmentId(state, action: PayloadAction<string>) {
      state.selectedAssignmentId = action.payload
    },
    clearSelectedAssignmentId(state) {
      state.selectedAssignmentId = null
    },
    setResponseDetails(state, action: PayloadAction<AssignmentResponse>) {
      state.responseDetails = action.payload
    },
    clearResponseDetails(state) {
      state.responseDetails = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setSelectedClientId, (state) => {
        state.responseDetails = null
      })
      .addCase(clearSelectedClientId, (state) => {
        state.responseDetails = null
      })
  },
})

export default assignmentsSlice.reducer

export const { setSelectedAssignmentId, clearSelectedAssignmentId, setResponseDetails, clearResponseDetails } =
  assignmentsSlice.actions
